import api from './api';

export interface CashBox {
  id: number;
  name: string;
  bank: string;
  accountType: string;
  accountNumber: string;
  currency: string;
  cbu?: string;
  alias?: string;
  balance: number;
  isActive: boolean;
  accountingType: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCashBoxPayload {
  name: string;
  accountType: string;
  currency: string;
  bank?: string;
  accountNumber?: string;
  cbu?: string;
  alias?: string;
  balance?: number;
  isActive?: boolean;
  accountingType?: string;
}

interface CashBoxResponse {
  success: boolean;
  message: string;
  data: CashBox[];
  timestamp: string;
}

interface SingleCashBoxResponse {
  success: boolean;
  message: string;
  data: CashBox;
  timestamp: string;
}

const cashBoxService = {
  // Obtener todas las cajas
  getAllCashBoxes: async (): Promise<CashBox[]> => {
    try {
      const response = await api.get<CashBoxResponse>('/cash-boxes');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching cash boxes:', error);
      throw error;
    }
  },

  // Crear una nueva caja
  createCashBox: async (payload: CreateCashBoxPayload): Promise<CashBox> => {
    try {
      const response = await api.post<SingleCashBoxResponse>(
        '/cash-boxes',
        payload,
      );
      return response.data.data;
    } catch (error) {
      console.error('Error creating cash box:', error);
      throw error;
    }
  },

  // Actualizar una caja existente
  updateCashBox: async (id: number, payload: Partial<CreateCashBoxPayload>): Promise<CashBox> => {
    try {
      const response = await api.put<SingleCashBoxResponse>(`/cash-boxes/${id}`, payload);
      return response.data.data;
    } catch (error) {
      console.error('Error updating cash box:', error);
      throw error;
    }
  },

  // Eliminar una caja
  deleteCashBox: async (id: number): Promise<void> => {
    try {
      await api.delete(`/cash-boxes/${id}`);
    } catch (error) {
      console.error('Error deleting cash box:', error);
      throw error;
    }
  },
};

export default cashBoxService;
